<template>
	<app-button size="small" @click="open = true">{{ button }}</app-button>

	<confirm-dialog
		:open="open"
		:title="title"
		theme="info"
		button="Done"
		:cancel="false"
		@confirmed="open = false">
		<slot></slot>
	</confirm-dialog>
</template>

<script lang="ts" setup>
	import { ref } from 'vue'

	defineProps({
		button: {
			type: String,
			default: 'Notes'
		},
		title: {
			type: String,
			default: 'Contract Notes'
		}
	})

	const open = ref(false)
</script>
